export const SET_TRACK_USERS = "setTrackUsers";
export const CLEAR_TRACK_USERS = "clearTrackUsers";
export const SET_USERS = "setUsers";
export const CLEAR_USERS = "clearUsers";
export const SET_TOTAL_USERS = "setTotalUsers";
export const CLEAR_TOTAL_USERS = "clearTotalUsers";
export const SET_EMAILS = "setEmails";
export const SET_TEAM = "setTeam";
export const SET_INVITE = "setInvite";
export const CLEAR_INVITE = "clearInvite";
